export default __webpack_public_path__ + "static/media/checkbox-circle-line.58d6d98b.svg";